(function () {
  window.fsrMilestones = (window.fsrMilestones || []).filter((milestone) => {
    if (milestone.isFreeShipping) return true;
    return milestone.giftVariantId !== 'null';
  });

  let giftRunning = false;

  async function syncGiftsWithCart() {
    if (giftRunning) return false;

    giftRunning = true;

    try {
      let didChangeCart = false;
      const cartData = await window.cartFetch('/cart.js').then((response) => response.json());
      const cartTotalCents = cartData.total_price;
      const lineItems = cartData.items;
      const giftVariantIds = window.fsrMilestones
        .filter((milestone) => !milestone.isFreeShipping)
        .map((milestone) => milestone.giftVariantId);
      const itemsByVariantId = {};

      for (const lineItem of lineItems) {
        itemsByVariantId[lineItem.variant_id] = lineItem.quantity;
      }

      const newGiftsNeeded = window.fsrMilestones
        .filter((milestone) => !milestone.isFreeShipping && cartTotalCents >= milestone.targetCents)
        .map((milestone) => milestone.giftVariantId);
      const missingGifts = newGiftsNeeded.filter((variantId) => !itemsByVariantId[variantId]);
      const extraGifts = giftVariantIds.filter((variantId) => {
        return itemsByVariantId[variantId] && !newGiftsNeeded.includes(variantId);
      });

      if (!missingGifts.length && !extraGifts.length) return false;

      if (extraGifts.length) {
        didChangeCart = true;
        const updates = {};

        for (const extraId of extraGifts) {
          const lineItem = cartData.items.find((item) => item.variant_id == extraId);
          if (lineItem) updates[lineItem.key] = 0;
        }

        if (Object.keys(updates).length > 0) {
          await window.cartFetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates })
          });
        }
      }

      if (missingGifts.length) {
        didChangeCart = true;

        for (const variantId of missingGifts) {
          const addResponse = await window.cartFetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: 1 })
          });

          if (!addResponse.ok) {
            console.error('[FSR-Gift] Error adding gift variantId:', variantId);
          }
        }
      }

      return didChangeCart;
    } catch (error) {
      console.error('[FSR-Gift] Error in syncGiftsWithCart:', error);
      return false;
    } finally {
      giftRunning = false;
    }
  }

  if (window.CartCoordinator) {
    CartCoordinator.register('gifts', syncGiftsWithCart);

    const runInitialReconcile = function () {
      CartCoordinator.run();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', runInitialReconcile, { once: true });
    } else {
      runInitialReconcile();
    }
  } else {
    console.warn('[FSR-Gift] CartCoordinator not found; gift reconciliation was not registered');
  }
})();
